import EmblaCarousel from 'embla-carousel';

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
    else prevBtn.setAttribute('disabled', 'disabled');

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
    else nextBtn.setAttribute('disabled', 'disabled');
  };

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState);

  return () => {
    prevBtn.removeAttribute('disabled');
    nextBtn.removeAttribute('disabled');
  };
};

export const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
  };
  prevBtn.addEventListener('click', scrollPrev, false);
  nextBtn.addEventListener('click', scrollNext, false);

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn,
  );

  return () => {
    removeTogglePrevNextBtnsActive();
    prevBtn.removeEventListener('click', scrollPrev, false);
    nextBtn.removeEventListener('click', scrollNext, false);
  };
};

const emblaNodes = document.querySelectorAll('.embla.js-gallery-slider');
if (emblaNodes.length > 0) {
  for (const embla of emblaNodes) {
    const viewportNode = embla.querySelector('.embla__viewport') as HTMLElement;
    const prevBtnNode = embla.querySelector('.embla__btn--prev') as HTMLElement;
    const nextBtnNode = embla.querySelector('.embla__btn--next') as HTMLElement;

    const slidesCount = embla.querySelectorAll('.embla__slide')?.length || 0;

    const emblaApi = EmblaCarousel(viewportNode, {
      loop: true,
      align: 'start',
      breakpoints: {
        '(min-width: 1024px)': { active: slidesCount > 3 }, // Only init when there are more than 3 items
      },
    });

    // Add Active Class to Embla Node
    emblaApi.on('init', (emblaApi) => {
      // Slider not initialized yet
      if (!emblaApi) {
        return;
      }

      if (emblaApi.internalEngine().options.active) {
        emblaApi.rootNode().closest('.embla').classList.add('embla--active');
      } else {
        emblaApi.rootNode().closest('.embla').classList.remove('embla--active');
      }
    });

    // Add Active Class to Embla Node on ReInit
    emblaApi.on('reInit', (emblaApi) => {
      if (emblaApi.internalEngine().options.active) {
        emblaApi.rootNode().closest('.embla').classList.add('embla--active');
      } else {
        emblaApi.rootNode().closest('.embla').classList.remove('embla--active');
      }
    });

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtnNode,
      nextBtnNode,
    );

    emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
  }
}
